// extracted by mini-css-extract-plugin
module.exports = {"commentContainer":"comment-item_commentContainer__2kAvA","owner":"comment-item_owner__1Unr8","dateText":"comment-item_dateText__29dTn","delete":"comment-item_delete__3PoSS"};